module.exports = __webpack_public_path__ + "static/media/more-ways-to-pay_mbgpb7.79ded005.png";